export enum CacheVariables {
  UserInfo = 'USER_INFO',
  UserInboxes = 'USER_INBOXES',
  ReportingUsers = 'REPORTING_USERS',
  CreateInsuredOptions = 'CREATE_INSURED_OPTIONS',
  AssignmentQueues = 'ASSIGNMENT_QUEUES',
}
